export const business = {
  name: '아이플레이',
  productName: '아이로그',
  brandEn: 'i-LOG',
  representative: '정하은',
  registrationNumber: '412-11-24045',
  address: '강원특별자치도 춘천시 충혼길52번길 10, 온의동 3층 301호(온의동)',
  email: 'contact@iplay.kr',
  businessTypes: [
    '응용 소프트웨어 개발 및 공급업',
    '광고 대행업',
    '미디어 콘텐츠 창작업',
    '기타 교육지원 서비스업',
  ],
  openedAt: '2025-11-01',
};
